'use strict';

window.Recon = window.Recon || {};

window.Recon.isBrowserSupported = function () {
  // Using http://caniuse.com/#feat=pagevisibility support to target browsers
  return document.visibilityState !== undefined;
};

var $ = require('jquery');

$(function () {

  var $loginForm = $('#login-form');
  var $unsupportedMessage = $('#unsupported-browser-message');

  if (window.Recon.isBrowserSupported()) {
    $loginForm.removeClass('hidden');
    $unsupportedMessage.addClass('hidden');
  } else {
    $loginForm.addClass('hidden');
    $unsupportedMessage.removeClass('hidden');
  }

  if (_.endsWith(window.location.search, 'logout')) {
    $('#logoutSuccess').toggle();
  }

  if (_.endsWith(window.location.search, 'error')) {
    $('#loginFailure').toggle();
  }

  if (_.endsWith(window.location.search, 'locked')) {
    $('#accountLocked').toggle();
  }

});



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/login.js
// module id = 566
// module chunks = 0